/* import __COLOCATED_TEMPLATE__ from './contact-wrapper.hbs'; */
import Component from '@glimmer/component';
import styles from './contact-wrapper.module.scss';

export default class ContactContactWrapper extends Component {
  styles = styles;
}
